import { useState, useEffect } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Menu,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import StateCom from "./StateCom";
import FiltersCom from "./FiltersCom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import OrdersGrid from "./OrdersGrid";
import { useNavigate, useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function Orders() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [anchorEl, setAnchorEl] = useState(null);
  const [stateCounts, setStateCounts] = useState();
  const openD = Boolean(anchorEl);
  const [refresh, setRefresh] = useState(false);
  const { isSmall } = useBreakpoints();

  const [isAll, setIsAll] = useState(true);
  const [searchName, setSearchName] = useState(
    location.state && location.state.searchName
      ? location.state.searchName
      : "جستجو همه"
  );
  const [searchColumn, setSearchColumn] = useState(
    location.state && location.state.searchColumn
      ? location.state.searchColumn
      : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const [searchSend, setSearchSend] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const [orderState, setOrderState] = useState(
    searchParams && searchParams.get("state") ? searchParams.get("state") : "1"
  );
  const [orderFilter, setOrderFilter] = useState(
    location.state && location.state.orderFilter
      ? location.state.orderFilter
      : "0"
  );

  useEffect(() => {
    window.history.replaceState({}, document.title);
    if (location && location.hash) {
      setSearch(location.hash.replace("#", ""));
      setSearchSend(
        location.hash.replace("#", "") ? location.hash.replace("#", "") : ""
      );
      setRefresh(true);
      if (isAll) {
        setOrderState(7);
        setOrderFilter(0);
        return navigate(`/orders?state=7`);
      }
    }
    if (
      !searchParams ||
      !searchParams.get("state") ||
      searchParams.get("state") == null
    ) {
      return navigate(`/orders?state=1`);
    }
  }, [searchParams]);

  useEffect(() => {
    if (location.state && location.state.orderState) {
      setOrderState(location.state.orderState);
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        title: "سفارشات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/orders" }],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ mb: 1, display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <StateCom
              stateCounts={stateCounts}
              orderState={orderState}
              setOrderState={setOrderState}
              setRefresh={setRefresh}
              setSearch={setSearch}
              setOrderFilter={setOrderFilter}
              setSearchSend={setSearchSend}
            ></StateCom>
            <Box
              sx={{
                display: "flex",
                alignItems: isSmall ? "flex-start" : "center",
                flexDirection: isSmall ? "column" : "row",
                justifyContent: "space-between",
                mt: 1,
              }}
            >
              <FiltersCom
                setRefresh={setRefresh}
                orderFilter={orderFilter}
                setOrderFilter={setOrderFilter}
              ></FiltersCom>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: isSmall ? "100%" : "30%",
                  mt: 2,
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{ p: 0 }}
                      checked={isAll}
                      onChange={(event) => setIsAll(event.target.checked)}
                    />
                  }
                  label="همه"
                />
                <TextField
                  sx={{
                    "& .MuiInputLabel-root": {
                      fontSize: "0.9rem !important",
                    },
                  }}
                  label={searchName}
                  value={search ? search : ""}
                  onChange={(evt) => {
                    if (location.state && location.state.search) {
                      location.state.search = "";
                    }
                    if (evt.target.value == "") {
                      setSearchSend("");
                    }
                    setSearch(evt.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      if (location.state && location.state.search) {
                        location.state.search = null;
                      }
                      setSearchSend(search ? search : "");
                      setRefresh(true);
                      if (isAll) {
                        setOrderState(7);
                        setOrderFilter(0);
                        return navigate(`/orders?state=7`);
                      }
                    }
                  }}
                  fullWidth
                  InputProps={{
                    autoComplete: "off",
                    inputProps: {
                      min: 1,
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          id="basic-button"
                          aria-controls={openD ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={openD ? "true" : undefined}
                          onClick={(event) => setAnchorEl(event.currentTarget)}
                          edge="end"
                        >
                          <MoreVertIcon
                            fontSize="small"
                            sx={{ color: "primary.main" }}
                          />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openD}
                  onClose={() => setAnchorEl(null)}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  sx={{}}
                >
                  <MenuItem
                    onClick={() => {
                      setSearchName("جستجو همه");
                      setSearchColumn("ALL");
                      setAnchorEl(null);
                    }}
                  >
                    همه
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setSearchName("جستجو براساس شماره سفارش");
                      setSearchColumn("Id");
                      setAnchorEl(null);
                    }}
                  >
                    شماره سفارش
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setSearchName("جستجو براساس نام و نام خانوادگی");
                      setSearchColumn("FullName");
                      setAnchorEl(null);
                    }}
                  >
                    نام و نام خانوادگی
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setSearchName("جستجو براساس نام");
                      setSearchColumn("FirstName");
                      setAnchorEl(null);
                    }}
                  >
                    نام
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setSearchName("جستجو براساس نام خانوادگی");
                      setSearchColumn("LastName");
                      setAnchorEl(null);
                    }}
                  >
                    نام خانوادگی
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setSearchName("جستجو براساس موبایل");
                      setSearchColumn("Mobile");
                      setAnchorEl(null);
                    }}
                  >
                    موبایل
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setSearchName("جستجو براساس تلفن");
                      setSearchColumn("Phone");
                      setAnchorEl(null);
                    }}
                  >
                    تلفن
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setSearchName("جستجو براساس شهر");
                      setSearchColumn("City");
                      setAnchorEl(null);
                    }}
                  >
                    شهر
                  </MenuItem>
                </Menu>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <OrdersGrid
            orderState={orderState}
            setOrderState={setOrderState}
            orderFilter={orderFilter}
            setOrderFilter={setOrderFilter}
            setStateCounts={setStateCounts}
            searchColumn={searchColumn}
            search={searchSend}
            setSearch={setSearch}
            searchName={searchName}
            refresh={refresh}
            setRefresh={setRefresh}
          />
        </Box>
      </Box>
    </Detail>
  );
}
